// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"330":"c0471942","361":"84e3727b","392":"0b708512","421":"6a759354","680":"7b4d408f","873":"e830904e","875":"73ed7ce1","937":"22f63800"}[chunkId] + ".chunk.css";
};